export default __webpack_public_path__ + "static/Yucatan-25a730983e22f5bfb0615449eb8c2f05.jpg";